module.exports = __webpack_public_path__ + "static/media/arrow-right.a9e719d5.svg";